import React, { createContext, useContext, useMemo, useState } from "react";

const HeaderContext = createContext({
  verticalId: null,
  setVerticalId: () => {},
});

export const HeaderProvider = ({ children }) => {
  const [verticalId, setVerticalId] = useState(null);
  const value = useMemo(() => ({ verticalId, setVerticalId }), [verticalId]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};

export const useHeaderContext = () => useContext(HeaderContext);
